<template>
  <div class="incoming-request">
    <div
      class="incoming-call-title d-flex align-end justify-space-between"
      :class="{ receive: isReceive }"
    >
      <span class="font-weight-medium">{{ getTitle }}</span>
      <icon-incoming-request />
    </div>
    <div class="incoming-call-info d-flex align-start justify-space-between">
      <div class="incoming-request-courier">
        <avatar
          v-if="transaction"
          class="mr-3"
          :user="transaction.sender"
          :border="false"
        />
        <div>
          <span class="label">Курьер</span>
          <span class="client-name font-weight-medium">{{
            getCourierName
          }}</span>
        </div>
      </div>
    </div>
    <div class="button-group d-flex a-center j-between">
      <v-btn
        class="button button-cancel font-weight-medium"
        height="60px"
        dark
        depressed
        @click="close"
      >
        <font-awesome-icon color="#ff9100" width="19px" icon="times" />
        Отмена
      </v-btn>
      <v-btn
        class="button button-apply font-weight-medium"
        color="#ffffff"
        height="60px"
        dark
        depressed
        @click="openRequest"
      >
        <font-awesome-icon icon="chevron-right" color="#ffffff" class="mr-1" />
        {{ getButtonCaption }}
      </v-btn>
    </div>
  </div>
</template>

<script>
  import IconIncomingRequest from '../icons/IconIncomingRequest'
  import Avatar from '@/components/administrator/work-shift/staff/Avatar.vue'

  export default {
    name: 'IncomingRequest',
    components: {
      Avatar,
      IconIncomingRequest,
    },
    props: {
      callEvent: {
        type: Object,
        default: () => ({}),
      },
      transaction: {
        type: Object,
        default: () => ({}),
      },
      showButtonOrder: Boolean,
    },
    computed: {
      isReceive () {
        return this.transaction.operationType === 'receive'
      },
      getButtonCaption () {
        return this.isReceive ? 'ВЫДАТЬ ДЕНЬГИ' : 'ПРИНЯТЬ ДЕНЬГИ'
      },
      getCourierName () {
        try {
          return this.transaction.sender.firstName
        } catch {
          return 'Курьер'
        }
      },
      getTitle () {
        if (this.transaction.operationType === 'receive') {
          return 'Запрос выдачи денег курьеру'
        } else if (this.transaction.operationType === 'send') {
          return 'Запрос на пополнение кассы'
        }
        return ''
      },
      getClientName () {
        return this.callEvent.clientName
          ? this.callEvent.clientName
          : 'Новый клиент'
      },
    },
    methods: {
      close () {
        this.$emit('close')
      },
      openRequest () {
        this.$emit('open-request')
        this.close()
      },
    },
  }
</script>

<style lang="less" scoped>
.incoming-request {
  min-height: 277px;
  padding: 0 0 23px 0;
  // padding: 38px 33px 23px 33px;
  position: fixed;
  right: 20px;
  bottom: 23px;
  background-color: #e3e3e3;
  // background-color: @color-primary;
  border-radius: 10px;
  max-width: 450px;
  width: 100%;
  z-index: 100;

  .button-close {
    position: absolute;
    right: 18px;
    top: 18px;
    width: 32px;
    height: 32px;
    svg {
      width: 24px;
      height: 24px;
    }
  }

  .incoming-call-title {
    display: block;
    padding: 38px 33px 18px;
    color: #ffffff;
    font-size: 29px;
    line-height: 1;
    margin-bottom: 35px;
    background-color: @color-primary;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;

    &.receive {
      background-color: #0033ff;
    }
  }

  .label {
    display: block;
    font-size: 14px;
    line-height: 19px;
    color: #333333;
  }

  .incoming-call-info {
    margin-bottom: 43px;
    padding-left: 33px;
    padding-right: 33px;

    .client-name {
      color: #333333;
      font-size: 29px;
      line-height: 1;
    }

    .order-number {
      font-size: 20px;
      line-height: 29px;
      color: #333333;
    }
  }

  .button-group {
    padding-left: 33px;
    padding-right: 33px;
  }

  .button {
    flex: 1;
    background-color: @color-primary !important;
    border-radius: 100px;
    font-size: 16px;
    color: #ffffff;
    &:first-child {
      margin-right: 10px;
    }
  }

  .button-cancel {
    background-color: #ffffff !important;
    color: #333333;
    svg {
      margin-right: 12px;
      height: 18px;
      width: 18px;
      .fill-svg(@color-error);
    }
  }

  &-courier {
    display: flex;
    align-items: center;
  }
}
</style>
